/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AgentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/agentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { AgentListBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/agentListBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { CallControlBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/callControlBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { CallHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/callHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { DirectoryBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/directoryBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { DirectoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/directoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { DynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/dynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { GeneralBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/generalBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { GrafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/grafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { InnerWallBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/innerWallBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { PresenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/presenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { SingleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/singleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { StageBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/stageBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { TabBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/tabBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { ToolbarBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/toolbarBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { UserStatusBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/userStatusBrickSettingRemoteDtoChangeBrickSettingRequestData';
import { WebViewerBrickSettingRemoteDtoChangeBrickSettingRequestData } from '../model/webViewerBrickSettingRemoteDtoChangeBrickSettingRequestData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BrickSettingsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeAgentDetailsBrickSettings(body?: AgentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeAgentDetailsBrickSettings(body?: AgentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeAgentDetailsBrickSettings(body?: AgentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeAgentDetailsBrickSettings(body?: AgentDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/agent-details-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeAgentListBrickSettings(body?: AgentListBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeAgentListBrickSettings(body?: AgentListBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeAgentListBrickSettings(body?: AgentListBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeAgentListBrickSettings(body?: AgentListBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/agent-list-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeCallBrickSettings(body?: CallControlBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeCallBrickSettings(body?: CallControlBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeCallBrickSettings(body?: CallControlBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeCallBrickSettings(body?: CallControlBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/call-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeCallHistoryBrickSettings(body?: CallHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeCallHistoryBrickSettings(body?: CallHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeCallHistoryBrickSettings(body?: CallHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeCallHistoryBrickSettings(body?: CallHistoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/call-history-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeDirectoryBrickSettings(body?: DirectoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeDirectoryBrickSettings(body?: DirectoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeDirectoryBrickSettings(body?: DirectoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeDirectoryBrickSettings(body?: DirectoryBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/directory-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeDirectoryDetailsBrickSettings(body?: DirectoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeDirectoryDetailsBrickSettings(body?: DirectoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeDirectoryDetailsBrickSettings(body?: DirectoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeDirectoryDetailsBrickSettings(body?: DirectoryDetailsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/directory-details-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeDynamicActionsBrickSettings(body?: DynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeDynamicActionsBrickSettings(body?: DynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeDynamicActionsBrickSettings(body?: DynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeDynamicActionsBrickSettings(body?: DynamicActionsBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/dynamic-actions-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeGeneralBrickSettings(body?: GeneralBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeGeneralBrickSettings(body?: GeneralBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeGeneralBrickSettings(body?: GeneralBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeGeneralBrickSettings(body?: GeneralBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/general-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeGrafanaDashboardViewerBrickSettings(body?: GrafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeGrafanaDashboardViewerBrickSettings(body?: GrafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeGrafanaDashboardViewerBrickSettings(body?: GrafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeGrafanaDashboardViewerBrickSettings(body?: GrafanaDashboardViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/grafana-dashboard-viewer-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeInnerWallBrickSettings(body?: InnerWallBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeInnerWallBrickSettings(body?: InnerWallBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeInnerWallBrickSettings(body?: InnerWallBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeInnerWallBrickSettings(body?: InnerWallBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/inner-wall-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changePresenceDurationBrickSettings(body?: PresenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changePresenceDurationBrickSettings(body?: PresenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changePresenceDurationBrickSettings(body?: PresenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changePresenceDurationBrickSettings(body?: PresenceDurationBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/presence-duration-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeSingleCallTagEditorBrickSettings(body?: SingleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeSingleCallTagEditorBrickSettings(body?: SingleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeSingleCallTagEditorBrickSettings(body?: SingleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeSingleCallTagEditorBrickSettings(body?: SingleCallTagEditorBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/single-call-tag-editor-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeStageBrickSettings(body?: StageBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeStageBrickSettings(body?: StageBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeStageBrickSettings(body?: StageBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeStageBrickSettings(body?: StageBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/stage-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeTabBrickSettings(body?: TabBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeTabBrickSettings(body?: TabBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeTabBrickSettings(body?: TabBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeTabBrickSettings(body?: TabBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/tab-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeToolbarBrickSettings(body?: ToolbarBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeToolbarBrickSettings(body?: ToolbarBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeToolbarBrickSettings(body?: ToolbarBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeToolbarBrickSettings(body?: ToolbarBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/toolbar-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeUserStatusBrickSettings(body?: UserStatusBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeUserStatusBrickSettings(body?: UserStatusBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeUserStatusBrickSettings(body?: UserStatusBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeUserStatusBrickSettings(body?: UserStatusBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/user-status-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeWebViewerBrickSettings(body?: WebViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public changeWebViewerBrickSettings(body?: WebViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public changeWebViewerBrickSettings(body?: WebViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public changeWebViewerBrickSettings(body?: WebViewerBrickSettingRemoteDtoChangeBrickSettingRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/brick-settings/web-viewer-brick-settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
